export default __webpack_public_path__ + "static/media/hdfcbanksleek.0db8d84eea1c0409246dd39518eaa0c8.webp";